import { Navigate } from "react-router";

import { APP_ROUTES } from "@/core/constants";
import type { AppRouteDefinition } from "@/core/router";

import { SignInPage } from "../views";

export const authRoutes: readonly AppRouteDefinition[] = [
  {
    route: APP_ROUTES.auth.signIn,
    element: <SignInPage />,
  },
  {
    id: "authSignInLegacy",
    route: APP_ROUTES.auth.signIn,
    element: <Navigate replace to={APP_ROUTES.auth.signIn.path} />,
    path: "/auth/sign-in",
  },
] as const;
